import { config as appConfig } from 'config';

export const config = {
  apiKey: appConfig.amplitude.apiKey,
};
